import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  submitSeperation,
  uploadFileWithPresignedUrl,
} from "../../store/SeperationSlice/thunk";
import { seperationActions } from "../../store/SeperationSlice";
import SeparationForm from "../SeparationForm";
import SubmitIcon from "../../assets/icons/inventory.svg";
import BackIcon from "../../assets/icons/arrow_back.svg";
import CloseIcon from "../../assets/icons/close.svg";
import moment from "moment";
import CommonModal from "../../commonComponents/CommonModal";
import "./SeperationList.css";

const SeperationList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const openModalRef = useRef();
  const closeModalRef = useRef();

  const [employeeSelected, setEmployeeSelected] = useState("");  
  const [formDataErr, setFormDataErr] = useState(false);
  const [dateOfResignErr, setDateOfResignErr] = useState(false);

  const mandatoryFields = [
    "employee_id",
    "resignation_date",
    "final_date_of_exit",
    "future_rehire",
    "recovery_days",
    "final_sepration_type",
    "reason",
    "reason_comments",
  ];

  const bulkEmployeeList = useSelector(
    (state) => state.seperation.bulkEmployeeList || []
  );
  const submitSeperationResponseStatus = useSelector(
    (state) => state.seperation.submitSeperationResponseStatus || ""
  );

  useEffect(() => {
    return () => {
      dispatch(seperationActions.resetBulkEmployeeList());
      dispatch(seperationActions.resetSubmitSeperationResponse());
    };
  }, []);

  useEffect(() => {
    if (bulkEmployeeList.length > 0) {
      setEmployeeSelected(bulkEmployeeList[0]);
    } else {
      setEmployeeSelected(null);
      navigate("./seperation");
    }
  }, [bulkEmployeeList]);

  // useEffect(() => {
  //   if (employeeSelected?.resignation_date && employeeSelected?.req_last_date) {
  //     const resignationDate = moment(employeeSelected?.resignation_date);
  //     const requestedLastDate = moment(employeeSelected?.req_last_date);
  //     const differenceInDays = requestedLastDate.diff(resignationDate, "days");

  //     // Update recovery_days in employeeFormData
  //     setEmployeeSelected((prevData) => ({
  //       ...prevData,
  //       recovery_days: differenceInDays,
  //     }));
  //   }
  // }, [employeeSelected?.resignation_date, employeeSelected?.req_last_date]);

  useEffect(() => {
    if (submitSeperationResponseStatus === "SUCCESS") {
      onCloseModal();
      const checkEmployeeIndex = bulkEmployeeList.findIndex(
        (emp) => emp.employee_id === employeeSelected.employee_id
      );
      if (checkEmployeeIndex !== -1) {
        let updatedList = [...bulkEmployeeList];
        updatedList.splice(checkEmployeeIndex, 1);
        dispatch(seperationActions.setBulkEmployeeList(updatedList));
      }
    }
    if (submitSeperationResponseStatus === "ERROR") {
      onCloseModal();
    }
  }, [submitSeperationResponseStatus]);

  const removeEmployeeFromList = (employee_id) => {
    const checkEmployeeIndex = bulkEmployeeList.findIndex(
      (emp) => emp.employee_id === employee_id
    );
    if (checkEmployeeIndex !== -1) {
      let updatedList = [...bulkEmployeeList];
      updatedList.splice(checkEmployeeIndex, 1);
      dispatch(seperationActions.setBulkEmployeeList(updatedList));
      if (employeeSelected?.employee_id === employee_id) {
        if (updatedList.length > 0) {
          setEmployeeSelected(updatedList[0]);
        } else {
          setEmployeeSelected(null);
        }
      }
    }
  };

  const onEmployeeUpdate = ({ key, value }) => {
    console.log("key, value", key, value);
    if (key === "resignation_date") {
      setEmployeeSelected({
        ...employeeSelected,
        final_date_of_exit: moment(value).add(60, "days").format("YYYY-MM-DD"),
        [key]: value,
      });
    } else if (key === "file") {
      dispatch(
        uploadFileWithPresignedUrl({
          employee_id: employeeSelected?.employee_id,
          file: value,
          key: "seperation",
        })
      );
      setEmployeeSelected({
        ...employeeSelected,
        [key]: value,
      });
    } else if (key === "final_sepration_type") {
      setEmployeeSelected({
        ...employeeSelected,
        [key]: value,
        reason: "",
      });
    } else {
      setEmployeeSelected({
        ...employeeSelected,
        [key]: value,
      });
    }
  };

  const validateFormdata = () => {
    setDateOfResignErr(false);
    setFormDataErr(false);

    // const checkIfDOEIsGreaterThanDOR =
    //   employeeSelected?.resignation_date &&
    //   employeeSelected?.req_last_date &&
    //   moment(new Date(employeeSelected?.req_last_date)).isSameOrAfter(
    //     moment(new Date(employeeSelected?.resignation_date))
    //   );
    // if (!checkIfDOEIsGreaterThanDOR) {
    //   setDateOfResignErr(true);
    //   return;
    // }

    let checkAllKeysExist = mandatoryFields.every(
      (key) =>
        employeeSelected[key] !== undefined &&
        employeeSelected[key] !== null &&
        employeeSelected[key] !== ""
    );
    console.log(
      "checkAllKeysExist",
      checkAllKeysExist,
      employeeSelected,
      mandatoryFields
    );

    if (!checkAllKeysExist) {
      setFormDataErr(true);
    } else {
      openModalRef.current.click();
    }
  };

  const onCloseModal = () => {
    closeModalRef.current.click();
  };

  const onSubmitEmployeeSeperation = () => {
    setFormDataErr(false);
    const formDataToSubmit = {
      ...employeeSelected,
      is_by_l1: false,
      bulk: true,
    };
    delete formDataToSubmit.file;
    delete formDataToSubmit.submit_check;
    console.log("formDataToSubmit", formDataToSubmit);
    dispatch(submitSeperation(formDataToSubmit));
  };

  const SeperationConfirm = () => (
    <div className="sp-confir">
      <div className="sp-cf-head">separation confirmation</div>
      <div className="sp-cf-subhead">
        Before Proceeding, please ensure you have checked all the details
        carefully.
      </div>
      <div className="sp-cf-content">
        <div className="sp-cf-label">Date of Resignation</div>
        <div className="sp-cf-value">
          {moment(employeeSelected?.resignation_date).format("DD MMMM YYYY")}
        </div>
      </div>
      <div className="sp-cf-content">
        <div className="sp-cf-label">Final Date Of Exit</div>
        <div className="sp-cf-value">
          {moment(employeeSelected?.final_date_of_exit).format("DD MMMM YYYY")}{" "}
          (60 Days)
        </div>
      </div>
      <div className="sp-cf-content">
        <div className="sp-cf-label">Rehire in Future</div>
        <div className="sp-cf-value">{employeeSelected?.future_rehire}</div>
      </div>
      <div className="sp-cf-btns">
        <button
          className="sp-cf-submit"
          onClick={() => {
            onSubmitEmployeeSeperation();
          }}
        >
          Submit
        </button>
        <button className="sp-cf-dismiss" onClick={() => onCloseModal()}>
          Dismiss
        </button>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col p-12">
      <div className="flex justify-between w-full">
        <div className="flex items-center">
          <img
            src={BackIcon}
            alt="icon"
            className="rq-home-btn-ico mr-2"
            onClick={() => {
              navigate("./seperation");
            }}
          />

          <div className="sp-head">separation list</div>
        </div>

        <div className="flex">
          {/* <button className="btn p-btn p-btn-blk">
            <img className="p-btn-icon" src={DraftIcon} alt="" />
            <div className="p-btn-text">Save as Draft</div>
          </button> */}
          <button
            className="btn p-btn p-btn-og"
            onClick={() => validateFormdata()}
          >
            <img className="p-btn-icon" src={SubmitIcon} alt="" />
            <div className="p-btn-text">Submit</div>
          </button>
        </div>
      </div>
      <div className="sp-list-nav">
        {bulkEmployeeList?.map((employee, index) => (
          <div
            className={`sp-list-item ${
              employeeSelected?.employee_id === employee?.employee_id
                ? "active"
                : ""
            }`}
            key={index}
            onClick={() => setEmployeeSelected(employee)}
          >
            <div className="sp-list-name whitespace-nowrap">
              ID #{employee?.employee_id}
            </div>
            <img
              className="sp-list-img"
              alt=""
              src={CloseIcon}
              onClick={() => removeEmployeeFromList(employee?.employee_id)}
            />
          </div>
        ))}
      </div>
      <div className="spl-list-form">
        <SeparationForm
          formData={employeeSelected}
          onUpdate={onEmployeeUpdate}
          isError={formDataErr}
          confirmationRequired={false}
          navRequired={false}
          isValidationError={dateOfResignErr}
        />
      </div>
      <CommonModal
        openRef={openModalRef}
        closeRef={closeModalRef}
        id={"separationConfirmModal"}
        hideCloseButton={false}
        content={<SeperationConfirm />}
        disabled={false}
        size={"md"}
      />
    </div>
  );
};
export default SeperationList;
